import chalk from "chalk";

import type { RuntimeUiChannel } from "./events.js";
import { getRuntimeUiChannelIdentity } from "./channelIdentity.js";

export type RuntimeUiSemanticTag = "tool" | "result" | "preview" | "content";

export function formatRuntimeUiChannelHeader(channel: RuntimeUiChannel): string {
  return channelHeaderColor(channel)(`[${channelLabel(channel)}]`);
}

export function formatRuntimeUiSemanticTag(tag: RuntimeUiSemanticTag, state?: "ok" | "failed"): string {
  switch (tag) {
    case "tool":
      return chalk.magenta(`[${tag}]`);
    case "result":
      return state === "failed" ? chalk.red("[result]") : "[result]";
    case "preview":
    case "content":
      return `[${tag}]`;
  }
}

export function colorRuntimeUiText(channel: RuntimeUiChannel, text: string): string {
  return colorForChannel(channel)(text);
}

export function channelLabel(channel: RuntimeUiChannel): string {
  return getRuntimeUiChannelIdentity(channel).label;
}

function colorForChannel(channel: RuntimeUiChannel): (text: string) => string {
  switch (channel) {
    case "system":
      return chalk.gray;
    case "subagent":
      return chalk.cyan;
    case "lead":
      return (text: string) => text;
  }
}

function channelHeaderColor(channel: RuntimeUiChannel): (text: string) => string {
  switch (channel) {
    case "lead":
    case "system":
      return chalk.red.bold;
    case "subagent":
      return chalk.cyan.bold;
  }
}
